import api from './api';

// Matches the CongViecDto from the backend
export interface CongViecDto {
    id: number;
    tieuDe: string;
    noiDung?: string;
    loaiCongViecId: number;
    tenLoaiCongViec: string;
    maNguoiTao: string;
    tenNguoiTao: string;
    maNguoiXuLyHienTai: string;
    tenNguoiXuLyHienTai: string;
    maKhoaPhong: number;
    tenKhoaPhong: string;
    ngayTao: string;
    ngayHetHan?: string;
    mucDoUuTien: number;
    trangThai: number;
}

// Matches the CongViecLichSuDto from the backend
export interface CongViecLichSuDto {
    id: number;
    congViecId: number;
    maNguoiThucHien: string;
    tenNguoiThucHien: string;
    hanhDong: string;
    ghiChu?: string;
    thoiGianThucHien: string;
    duLieuThem?: string;
}

// This payload is for creating a task
export interface CongViecCreatePayload {
    tieuDe: string;
    noiDung?: string;
    loaiCongViecId: number;
    maNguoiNhan: string;
    maKhoaPhong: number;
    ngayHetHan?: string;
    mucDoUuTien: number;
}

// This payload is for workflow actions
export interface WorkflowActionPayload {
    ghiChu?: string;
    maNguoiNhanMoi?: string;
}

export const congViecService = {
    // === Task Types and Recipients ===
    getAllLoaiCongViec: () => {
        return api.get('/cong-viec-loai');
    },
    getRecipientsByLoaiCV: (loaiCvId: number) => {
        return api.get(`/cong-viec-loai/${loaiCvId}/recipients`);
    },

    // === Main Task CRUD ===
    getTasks: () => {
        // The backend will filter based on the user's token
        return api.get('/cong-viec');
    },
    getInvolvedTasks: () => {
        return api.get('/cong-viec/involved');
    },
    // For the management page, with filters
    getFilteredTasks: (params: { fromDate?: string, toDate?: string, loaiCongViecId?: number, maKhoaPhong?: number, trangThai?: number }) => {
        return api.get('/cong-viec/filter', { params });
    },

    createTask: (data: CongViecCreatePayload) => {
        return api.post('/cong-viec', data);
    },
    getTaskById: (id: number) => {
        return api.get(`/cong-viec/${id}`);
    },
    getTaskHistory: (id: number) => {
        return api.get(`/cong-viec/${id}/lich-su`);
    },

    // === Workflow Actions ===
    chuyenTiep: (id: number, payload: WorkflowActionPayload) => {
        return api.post(`/cong-viec/${id}/chuyen-tiep`, payload);
    },
    traLai: (id: number, payload: WorkflowActionPayload) => {
        return api.post(`/cong-viec/${id}/tra-lai`, payload);
    },
    xuLy: (id: number, payload: WorkflowActionPayload) => {
        return api.post(`/cong-viec/${id}/xu-ly`, payload);
    },
    hoanThanh: (id: number, payload: WorkflowActionPayload) => {
        return api.post(`/cong-viec/${id}/hoan-thanh`, payload);
    },
    tuChoi: (id: number, payload: WorkflowActionPayload) => {
        return api.post(`/cong-viec/${id}/tu-choi`, payload);
    },
    huyBo: (id: number, payload: WorkflowActionPayload) => {
        return api.post(`/cong-viec/${id}/huy-bo`, payload);
    }
};
